import { useState } from 'react';
import { BankhubDepositPanel } from './components/BankhubDepositPanel';
import { KeywordTab } from './components/KeywordTab';
import { MerchantLogoTab } from './components/MerchantLogoTab';

type TabKey = 'keyword' | 'logo' | 'deposit';

const TABS: { key: TabKey; label: string }[] = [
  { key: 'keyword', label: 'Đối soát' },
  { key: 'logo', label: 'Thương hiệu' },
  { key: 'deposit', label: 'Ký quỹ' },
];

export function PlatformConfigPage() {
  const [tab, setTab] = useState<TabKey>('keyword');

  return (
    <div className="p-6">
      <header className="mb-5">
        <h1 className="text-xl font-semibold text-surface-900">Cấu hình</h1>
        <p className="mt-1 text-[13px] text-surface-500">
          Cấu hình cấp nền tảng: từ khóa đối soát SePay, logo merchant và ký quỹ.
        </p>
      </header>

      <div className="mb-5 flex gap-1 border-b border-surface-200">
        {TABS.map((t) => (
          <button
            key={t.key}
            type="button"
            onClick={() => setTab(t.key)}
            className={
              tab === t.key
                ? '-mb-px border-b-2 border-brand-500 px-3 py-2 text-[13px] font-medium text-brand-700'
                : '-mb-px border-b-2 border-transparent px-3 py-2 text-[13px] text-surface-500 hover:text-surface-800'
            }
          >
            {t.label}
          </button>
        ))}
      </div>

      {tab === 'keyword' && <KeywordTab />}
      {tab === 'logo' && <MerchantLogoTab />}
      {tab === 'deposit' && <BankhubDepositPanel />}
    </div>
  );
}
